// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8bffdd50","337":"dcdc8ebf","455":"392011b0","488":"b18211bc"}[chunkId] + ".chunk.js";
};